import { Wave }                              from './wave';
import { Admin }                             from './admin';
import { FmRelease }                         from './fm-release';

export class GroupWaveSharedSingle {
  id: number;
  name: string;

  start_date: string;
  end_date: string;
  timezone: string;

  enrolment_subject: string;
  enrolment_message: string;

  include_in_all_time_leaders: boolean;
  include_in_team_leaders: boolean;
  hide_leaderboards: boolean;

  one_week_remaining: boolean;
  one_day_remaining: boolean;
  fm_release_notification: boolean;
  weekly_individual_leaders: boolean;
  weekly_top_teams: boolean;
  notify_users_after_inactivity: boolean;
  nudge_delay: number;
  notify_launch: boolean;
  notify_followup: boolean;
  notify_followup_delay: number;

  analytics_admins: Admin[];

  fm_releases: FmRelease[];
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/models/program/group-wave-shared-single.ts